import React, { useEffect, useState } from 'react';

/**
 * Displays all disclaimers for the OmsInputField and all of its profile components and addOns.
 *
 * @param omsInputField Any OMSInputField, but typically an OmsRequisition.OrderableItem.ProfileList element
 */
export default function ProfileDisclaimers({ omsInputField }) {
	const [disclaimers, setDisclaimers] = useState([]);

	useEffect(() => {
		setDisclaimers(getInputFieldDisclaimers(omsInputField));
	}, [omsInputField]);

	if (!disclaimers?.length) {
		return null;
	}

	return (
		<div className="profile-disclaimers">
			{disclaimers.map((disclaimer, index) => {
				return (
					<div key={index} className="text-prewrap small text-warning bold">
						{disclaimer}
					</div>
				);
			})}
		</div>
	);
}

/**
 * Crawls the OMS Input Field structure to generate a distinct array of 
 * disclaimers on the input field, its profile components, and its addOns.
 */
const getInputFieldDisclaimers = (omsInputField) => {
	let disclaimers = [];

	if (omsInputField?.disclaimer) {
		disclaimers = disclaimers.concat(omsInputField.disclaimer);
	}

	if (omsInputField?.profileComponents?.length) {
		omsInputField.profileComponents.forEach((profileComponent) => {
			disclaimers = disclaimers.concat(getInputFieldDisclaimers(profileComponent));
		});
	}

	if (omsInputField?.addOnList?.length) {
		omsInputField.addOnList.forEach((addOn) => {
			disclaimers = disclaimers.concat(getInputFieldDisclaimers(addOn));
		});
	}

	// Convert to a Set to remove duplicates and then back to an array
	return [...new Set(disclaimers)];
};
